import React from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import AddButton from 'shared/ui/AddButton';
import { openModal } from 'store/modals/actions';
import { MODAL_AGENT_CREATE } from 'store/modals/modals';
import Wrapper from './styled';
import { selectAllowedByRole } from 'Hooks/usePermission/selector';
import { FEATURE_AGENTS, PERMISSION_TYPES } from 'Hooks/usePermission/permissions';

const CreateButton = ({
  showSeparator, modalId = MODAL_AGENT_CREATE, labelId = 'agents.create.title', labelDefault, feature = FEATURE_AGENTS
}) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const canCreate = useSelector((state) => selectAllowedByRole(state, feature, PERMISSION_TYPES.CREATE));
  const label = intl.formatMessage({ id: labelId, defaultMessage: labelDefault });
  const handleClick = () => {
    if (canCreate) dispatch(openModal(modalId));
  };

  return (
    <Wrapper showSeparator={ showSeparator }>
      <AddButton title={ label } onClick={ handleClick } disabled={ !canCreate }>
        { label }
      </AddButton>
    </Wrapper>
  );
};
export default CreateButton;
